//==================  subscribe_opt change add to cart add input value ======================= //
document.addEventListener('change', function (event) {
  if (event.target.matches('.block__product-grid-plan-list input[type=radio]')) {
    const radio = event.target;
    const card = radio.closest('.card-wrapper');
    const selectBox = card.querySelector('.block__product-grid-plan-list-dropbox');
    const variantAndSub = card.querySelector('.product-card-variant-and-sub');

    // --- Dropdown toggle logic ---
    if (radio.value === 'subscribe') {
      selectBox.classList.add('active');
      variantAndSub.classList.add('active');
    } else {
      selectBox.classList.remove('active');
      variantAndSub.classList.remove('active');
    }

    // --- Existing logic ---
    if (radio.checked && radio.value === "subscribe") {
      const subscribeOpt = card;
      const select = subscribeOpt.querySelector(".block__product-grid-plan-list-dropbox select");
      const getInputVal = select ? select.value : null;

      const subscriptionVal = card.querySelector(".block__product-card-subscription-val");
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }

      // Update hidden input when plan changes
      function handleSelectChange() {
        const selectedValue = select.value;
        if (subscriptionVal) {
          subscriptionVal.value = selectedValue;
        }
      }

      select.removeEventListener('change', handleSelectChange);
      select.addEventListener('change', handleSelectChange);
    } else {
      const getInputVal = radio.value;
      const subscriptionVal = card.querySelector(".block__product-card-subscription-val");
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }
    }

    // Reset quantity to 1 when switching plans
    const qty = card.querySelector("#quantity");
    if (qty) qty.setAttribute("value", 1);
  }
});


// function selectVariant(element) {
//   const selectedVariantId = element.value;
//   const variantInput = element.closest('.card__content').querySelector('.product-variant-id');
//   if (variantInput) {
//     variantInput.value = selectedVariantId;
//   }
// }

function selectCardOption(selectEl, productId) {
  const card = selectEl.closest('.card__content');
  const variants = JSON.parse(card.getAttribute('data-variants'));

  const matchedVariant = variants.find(v => v.id == selectEl.value);

  const variantInput = card.querySelector('.product-variant-id');
  const addBtn = card.querySelector('.quick-add__submit');

  // --- Price update elements ---
  const regularPriceEl = card.querySelector('.price__regular .price-item--regular');
  const salePriceEl = card.querySelector('.price__sale .price-item--sale');
  const comparePriceEl = card.querySelector('.price__sale s.price-item--regular');

  // --- Fallback money formatter ---
  const formatMoney = (amount) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(amount, Shopify.money_format);
    }
    // Fallback: format with commas and 2 decimals
    const number = (amount / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `$${number}`;
  };

  if (matchedVariant) {
    // Update price display
    if (matchedVariant.compare_at_price > matchedVariant.price) {
      // Show sale pricing
      if (salePriceEl) salePriceEl.textContent = formatMoney(matchedVariant.price);
      if (comparePriceEl) comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
    } else {
      // Regular price only
      if (regularPriceEl) regularPriceEl.textContent = formatMoney(matchedVariant.price);
    }

    // Enable Add to Cart if available
    if (matchedVariant.available) {
      variantInput.value = matchedVariant.id;
      variantInput.disabled = false;
      addBtn.disabled = false;
    } else {
      variantInput.value = '';
      variantInput.disabled = true;
      addBtn.disabled = true;
    }
  } else {
    // Reset state if invalid selection
    variantInput.value = '';
    variantInput.disabled = true;
    addBtn.disabled = true;
  }
}


//==================  subscribe_opt change price ======================= //

// document.querySelectorAll('.block__product-grid-plan input[type=radio]').forEach(function (radio) {
//     radio.addEventListener('click', function () {
//         const priceElement = this.closest(".block__product-grid-plan").querySelector(".block_product-grid_subscribe-price");
//         const getPrice = priceElement ? priceElement.getAttribute("data-price") : null;

//         const infoCard = this.closest(".card-wrapper");
//         const buttonPrice = infoCard.querySelector(".quick-add__submit .button-price");

//         if (buttonPrice) {
//             buttonPrice.textContent = getPrice;
//         }
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/pages/newsletter') {
    const target = document.querySelector('.newsletter');

    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});

//==================  subscribe_opt change price ======================= //

// document.querySelectorAll('.block__product-grid-plan-subscription input[type=radio]').forEach(function (radio) {
//     radio.addEventListener('click', function () {
//         const priceElement = this.closest(".block__product-grid-plan-subscription").querySelector(".block_product-grid_subscribe-price");
//         const getPrice = priceElement ? priceElement.getAttribute("data-price") : null;

//         const infoCard = this.closest(".card-wrapper");
//         const MainpriceElement = infoCard.querySelector(".price__sale .price-item--sale");

//         if (MainpriceElement) {
//             MainpriceElement.textContent = getPrice;
//         }
//     });
// });

// document.querySelectorAll('.block__product-grid-plan-input').forEach(function (radio) {

//   radio.addEventListener('change', function () {

//     const card = this.closest('.card-wrapper');
//     if (!card) return;

//     const label = card.querySelector(`label[for="${this.id}"]`);
//     if (!label) return;

//     const priceWrapper = card.querySelector('.price');
//     if (!priceWrapper) return;

//     const regularPrice = priceWrapper.querySelector('.price__regular .price-item--regular');
//     const salePrice = priceWrapper.querySelector('.price__sale .price-item--sale');
//     const comparePrice = priceWrapper.querySelector('.price__sale s');

//     const newPrice = label.getAttribute('data-price');
//     const compare = label.getAttribute('data-compare');

//     if (this.value === 'subscribe') {

//       if (regularPrice) regularPrice.textContent = newPrice;
//       if (salePrice) salePrice.textContent = newPrice;

//       if (comparePrice) comparePrice.style.display = 'none';

//       priceWrapper.classList.remove('price--on-sale');

//     } else {

//       if (regularPrice) regularPrice.textContent = newPrice;
//       if(salePrice) salePrice.textContent = newPrice;

//       if (comparePrice && compare) {
//         comparePrice.style.display = '';
//         comparePrice.textContent = compare;
//       }

//       if (compare && compare !== '$0.00') {
//         priceWrapper.classList.add('price--on-sale');
//       }

//     }

//   });

// });
document.addEventListener('change', function (event) {

  if (!event.target.matches('.block__product-grid-plan-input')) return;

  const radio = event.target;
  const card = radio.closest('.card-wrapper');
  if (!card) return;

  const variantContainer = card.querySelector('[data-variants]');
  if (!variantContainer) return;

  const variants = JSON.parse(
    variantContainer.getAttribute('data-variants')
  );

  const variantSelect = card.querySelector('select[name="id"]');
  if (!variantSelect) return;

  const selectedVariant = variants.find(
    v => v.id == variantSelect.value
  );

  if (!selectedVariant) return;

  const priceWrapper = card.querySelector('.price');
  if (!priceWrapper) return;

  const regularPriceEl = priceWrapper.querySelector('.price__regular .price-item--regular');
  const salePriceEl = priceWrapper.querySelector('.price__sale .price-item--sale');
  const comparePriceEl = priceWrapper.querySelector('.price__sale s');

  let basePrice = selectedVariant.price / 100;

  let comparePrice = selectedVariant.compare_at_price
    ? selectedVariant.compare_at_price / 100
    : null;

  let finalPrice = basePrice;

  // Apply subscription discount dynamically
  if (radio.value === 'subscribe') {

    const planSelect = card.querySelector(
      '.block__product-grid-plan-list-dropbox select'
    );

    const selectedPlan = planSelect?.selectedOptions[0];

    const discountPercent = parseFloat(selectedPlan?.dataset?.per);

    if (discountPercent) {
      finalPrice = basePrice - (basePrice * discountPercent / 100);
    }
  }

  // Safe currency formatter
  const formatMoney = (value) => {
    return '$' + value.toFixed(2);
  };

  const formattedPrice = formatMoney(finalPrice);
  const formattedCompare = comparePrice
    ? formatMoney(comparePrice)
    : null;

  // Update UI

  if (comparePrice && comparePrice > finalPrice) {

    if (salePriceEl) salePriceEl.textContent = formattedPrice;

    if (comparePriceEl) {
      comparePriceEl.textContent = formattedCompare;
      comparePriceEl.style.display = '';
    }

    priceWrapper.classList.add('price--on-sale');

  } else {

    if (regularPriceEl) regularPriceEl.textContent = formattedPrice;

    if (comparePriceEl) comparePriceEl.style.display = 'none';

    priceWrapper.classList.remove('price--on-sale');

  }

});